import React, { useState } from "react";
import { toast } from "react-toastify";
import { Form, Button, Container, Row, Col, Card } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import ApiService from "../services/ApiService";
import logo from "../assets/img/mse-logo.webp";
import Footer from "../components/Footer/Footer";

const Login = () => {
  const navigate = useNavigate();
  const [isLoader, setIsLoader] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const [formData, setFormData] = useState({
    username: "",
    password: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevFormData) => ({
      ...prevFormData,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoader(true);
    try {
      const response = await ApiService.request({
        method: "POST",
        url: `login`,
        data: formData,
      });
      const data = response.data;
      if (data.status) {
        toast.success(data.message);
        let user = data.data.user;
        user.auth_token = data.data.auth_token;
        localStorage.setItem("user", JSON.stringify(data.data.user));
        window.location.href = "/dashboard";
        navigate("/");
      } else {
        toast.error(data.message);
        if(!data.email_verified_at){
          let user = data.data.user;
          navigate("/verify-email?user_id="+user.id);
        }
      }
      setIsLoader(false);
    } catch (error) {
      toast.error("Login failed!");
      setIsLoader(false);
    }
  };

  return (
    <>
      <div className="topbar-border">
        <div className="nav-logo px-3 py-2">
          <img src={logo} alt="UCAT Logo" />
        </div>
      </div>

      <Container fluid className="mt-3 p-0 signIn-form">
        <div className="text-center header">
          <h1 className="fw-light pb-3">MSE</h1>
        </div>

        <Row className="justify-content-center">
          <Col md={8} className="p-4">
            <h4 className="mb-3">Sign in</h4>
            <p>
              Our secure website encrypts your personal information so that it
              cannot be read by unauthorized Internet users. For your security,
              please remember to sign out of your account and close your browser
              when you finish your session.
            </p>
            <p>
              Please do not use the back button to navigate the site. <br />
              <span className="text-danger">* Required information</span>
            </p>
          </Col>
          <Col md={5} className="signIn-form">
            <Card className="p-4">
              <h5 className="fw-light mb-4">
                Returning users, please sign in:
              </h5>

              <Form onSubmit={handleSubmit}>
                <Form.Group controlId="username" className="mb-3">
                  <Form.Label>* Username/Email:</Form.Label>
                  <Form.Control
                    type="text"
                    name="username"
                    value={formData.username}
                    onChange={handleChange}
                    required
                    className="w-50 inp-s"
                  />
                </Form.Group>

                <Form.Group controlId="password" className="mb-3">
                  <Form.Label>* Password:</Form.Label>
                  <div className="d-flex align-items-center">
                    <Form.Control
                      type={showPassword ? "text" : "password"}
                      name="password"
                      value={formData.password}
                      onChange={handleChange}
                      className="w-50 inp-s"
                      required
                    />
                    <Form.Check
                      type="checkbox"
                      label="Show password"
                      className="mt-2 mx-2"
                      id="showPassword"
                      onChange={() => setShowPassword((prev) => !prev)} // Toggle visibility
                    />
                  </div>
                </Form.Group>

                <Button type="submit" className="w-25 form-btn"   disabled={isLoader}>
                  Sign In 
                  {isLoader &&  <div class="spinner-border spinner-border-sm mx-2" role="status">    </div> } 
                </Button>
              </Form>

              <div className="mt-3">
                {/* <a href="#" className="text-decoration-none forgot-con">
                  I forgot my username
                </a> */}
                <br />
                <Link to={"/forgot-password"} className="text-decoration-none forgot-con">
                  I forgot my password
                </Link>
              </div>
            </Card>
          </Col>

          <Col md={3} className="mt-4 mt-md-0">
            <Card className="p-4">
              <h5>New users, please sign up:</h5>
              <Link to={"/Registration"} className="w-50 create-acc">
                Create a new account
              </Link>
            </Card>
          </Col>
        </Row>

        <Footer />
      </Container>
    </>
  );
};

export default Login;
